import { STAFF_OR_ABOVE } from "@excel-center/shared";

export const STAFF_AND_UP_ROLES = STAFF_OR_ABOVE;

export const AI_CHAT_MODEL = "claude-sonnet-4-6";
